import * as React from 'react';
import { useEffect, useState } from 'react';
import Modal from "../../../component/Global/Modal";
import ReusableDiv from 'src/support/ReusableDiv';
import { useUserStore } from "../../../hooks/admin/user";
import useReduxState from 'src/hooks/useReduxState';
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag';
import { __remove, __set } from "src/store/axios_indicator";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";

const RemoveUser = (props) => {
    const [status, SetStatus] = useState(false);
    const [{ }, { }, { delete_user }] = useUserStore();
    const [refreshGrid, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
    const [userListErrAlert, setUserListErrAlert] = useReduxState("", "setUserListErrAlert");
    const [errAlertType, setErrAlertType] = useReduxState("", "setErrAlertType");
    const [__check] = useAxiosIndicatorCheck();


    const userList = props.data;
    const [errMessage, setErrMessage] = useState('');

    useEffect(() => {
        SetStatus(true)
    }, []);

    const onHide = () => {
        SetStatus(false)
    };

    const onSubmit = async () => {
        let _removeList = userList.map(a => a.UserID);
        __set("REMOVE_USER_API_CALL");
        await delete_user(_removeList)
            .then((data) => {
                setErrMessage('');
                setUserListErrAlert('You have successfully removed User(s) from the system', 'success', 'removeUser');
                setErrAlertType('success');
                setRefreshGrid(true);
                onHide();
                __remove("REMOVE_USER_API_CALL");
            }).catch((err) => {
                setErrMessage(err.response?.data?.message || err.response?.data?.errorMessage || err.response?.data?.Message || 'Something went wrong');
                __remove("REMOVE_USER_API_CALL");
            })
    };

    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>
                <div className="avnet-modal modal-730">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => { onHide() }}>×</button>
                        {ReusableDiv.PopupTitle("Remove User")}
                        <div className="modal-body">
                            <p className="text-center mb-3"> <strong>You are about to remove this “User(s)” from all references
                                <br />associated to the them which includes all Sponsored accounts. </strong> </p>

                            <table className="bs5 table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Email  </th>
                                        <th>FIRST NAME </th>
                                        <th>LAST NAME</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userList.map((v, i) => (
                                        <tr key={v.UserID}>
                                            <td>{v.Email} </td>
                                            <td>{v.FirstName} </td>
                                            <td>{v.LastName} </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <p className="text-center mt-4">
                                Click “OK” to permanently remove User from the system.
                                <br /><span style={{ color: 'red' }}>  Note: you will not be able to reverse this action. </span>
                            </p>

                            {errMessage && <AlertContentWithFlag message={errMessage} type={'danger'} isDisplay={false} isDisplayIcon={true} />}
                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="bs5 btn btn-secondary minw140"
                                onClick={() => { onHide() }}>Cancel</button>
                            <button
                                type="button"
                                className="bs5 btn btn-primary minw140"
                                disabled={__check(["REMOVE_USER_API_CALL"]).status}
                                onClick={() => {
                                    __check(["REMOVE_USER_API_CALL"]).status
                                        ? e.preventDefault()
                                        : onSubmit();
                                }}                            >
                                {(__check("REMOVE_USER_API_CALL").status) ? (
                                    <i className="fa fa-spinner fa-spin" />
                                ) : (
                                    "OK"
                                )}{" "}
                            </button>
                        </div>
                    </div>
                </div>

            </Modal>
        </>
    )
}

export default RemoveUser;
